import { Mole } from 'state/vvsgotchi/models'
import { useHistory } from 'react-router-dom'
import { tierToIcon } from 'views/VvsGotchi/config'
import { Text, Flex, Img } from 'vvs-uikit'
import PixelatedImage from 'views/VvsGotchi/components/PixelatedImage'
import { useTranslation } from 'contexts/Localization'
import { formatUrlSearch } from 'utils/urlSearch'
import { Search, getVvsGotchiMoleProfilePath } from 'config/constants/paths'
import { EllipsisText, MoleAvatar } from '../styles'
import { ResponsiveGrid, Break, ResponsiveFooterGrid } from './styles'

interface IDataRowProps {
  mole: Mole
}
export const LeaderboardRow: React.FC<IDataRowProps> = ({ mole }) => {
  const { t } = useTranslation()
  const history = useHistory()
  const { rank, tokenId, name, imageUrl, tier, boost, totalExp } = mole
  const iconSrc = tierToIcon[tier]
  return (
    <ResponsiveGrid
      type="body"
      onClick={() =>
        history.replace({
          pathname: getVvsGotchiMoleProfilePath(tokenId.toString()),
          search: formatUrlSearch([Search.VVS_GOTCHI_LEADERBOARD[0], null]),
        })
      }
    >
      <Flex justifyContent="center">
        {rank === 1 ? <PixelatedImage src="/images/vvsGotchi/crown.png" width="34px" /> : rank}
      </Flex>
      <Flex alignItems="center" gap="4px" maxWidth={['120px', '120px', '170px']}>
        <MoleAvatar size="40px" rounded key={tokenId} image={imageUrl} />
        <EllipsisText color="darkestNightBlue" fontSize="13px" bold>
          {name}
        </EllipsisText>
      </Flex>
      <Flex alignItems="center" gap="4px">
        {iconSrc && <PixelatedImage src={iconSrc} />}
        <Text color="darkestNightBlue">{boost}x</Text>
      </Flex>
      <Flex alignItems="center" gap="4px">
        <Img src="/images/vvsGotchi/star.png" width="17.25px" />
        <Text color="darkestNightBlue" fontSize="13px">
          {totalExp > 0 ? totalExp.toFixed(1) : t('N.A.')}
        </Text>
      </Flex>
      <Break />
    </ResponsiveGrid>
  )
}

interface LeaderboardFooterRowProps extends IDataRowProps {
  index: number
}
export const LeaderboardFooterRow: React.FC<LeaderboardFooterRowProps> = ({ mole, index }) => {
  const { t } = useTranslation()
  const { rank, tokenId, name, imageUrl, tier, boost, totalExp } = mole
  const iconSrc = tierToIcon[tier]
  return (
    <ResponsiveFooterGrid>
      <Break hide={index === 0} />
      <Flex justifyContent="center">
        {rank === 1 ? (
          <PixelatedImage src="/images/vvsGotchi/crown.png" width="34px" />
        ) : (
          <Text color="white">{totalExp > 0 ? rank : t('N.A.')}</Text>
        )}
      </Flex>
      <Flex alignItems="center" gap="4px" maxWidth={['120px', '120px', '170px']}>
        <MoleAvatar size="40px" rounded key={tokenId} image={imageUrl} />
        <EllipsisText color="white" fontSize="13px" bold>
          {name}
        </EllipsisText>
      </Flex>
      <Flex alignItems="center" gap="4px">
        {iconSrc && <PixelatedImage src={iconSrc} />}
        <Text color="white">{totalExp > 0 ? `${boost}x` : t('N.A.')}</Text>
      </Flex>
      <Flex alignItems="center" gap="4px">
        <Img src="/images/vvsGotchi/star.png" width="17.25px" />
        <Text color="white" fontSize="13px">
          {totalExp.toFixed(1)}
        </Text>
      </Flex>
    </ResponsiveFooterGrid>
  )
}
